module.exports = __webpack_public_path__ + "img/career2.da1523e7.png";